
### thx to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects ###

'use strict'

module.exports = new Set [
  Object::
  Function::
  Boolean::
  Symbol::
  Error::
  AggregateError::
  EvalError::
  RangeError::
  ReferenceError::
  SyntaxError::
  TypeError::
  URIError::
  Number::
  BigInt::
  Math::
  Date::
  String::
  RegExp::
  Array::
  Int8Array::
  Uint8Array::
  Uint8ClampedArray::
  Int16Array::
  Uint16Array::
  Int32Array::
  Uint32Array::
  Float32Array::
  Float64Array::
  BigInt64Array::
  BigUint64Array::
  Map::
  Set::
  WeakMap::
  WeakSet::
  ArrayBuffer::
  SharedArrayBuffer::
  Atomics::
  DataView::
  JSON::
  Promise::
  Reflect::
  Proxy::
  Intl::
  Intl.Collator::
  Intl.DateTimeFormat::
  Intl.ListFormat::
  Intl.NumberFormat::
  Intl.PluralRules::
  Intl.RelativeTimeFormat::
  Intl.Locale::
  WebAssembly::
  WebAssembly::
  WebAssembly.Module::
  WebAssembly.Instance::
  WebAssembly.Memory::
  WebAssembly.Table::
  WebAssembly.CompileError::
  WebAssembly.LinkError::
  WebAssembly.RuntimeError::
  ]

  # Generator::
  # GeneratorFunction::
  # AsyncFunction::
  # AsyncGenerator::
  # AsyncGeneratorFunction::
  # Reflection::
